import { SanityInvestmentRangeBlock } from '../../types/generated/graphql-types'
import {
  InvestmentRangeBusinessSegmentColor,
  InvestmentRangeProps,
} from '../components/blocks/InvestmentRange'
import { notEmpty } from '../utilities/filters'

export const mapSanityInvestmentRangeToInvestmentRangeProps = ({
  _rawBody,
  businessSegments,
  footnotes,
  title,
}: SanityInvestmentRangeBlock): InvestmentRangeProps => ({
  body: _rawBody ?? undefined,
  businessSegments: businessSegments?.filter(notEmpty).map(businessSegment => ({
    color: (businessSegment.color ?? 'primary') as InvestmentRangeBusinessSegmentColor,
    investmentRanges:
      businessSegment.investmentRanges?.filter(notEmpty).map(investmentRange => ({
        investments: investmentRange.investments?.filter(notEmpty) ?? undefined,
        title: investmentRange.title ?? undefined,
      })) ?? undefined,
    title: businessSegment.title ?? undefined,
  })),
  footnotes: footnotes?.filter(notEmpty) ?? undefined,
  title: title ?? undefined,
})
